var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClient(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1735871504848,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 2324,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M473.58 284.54a15.48 15.48 0 0 1-13.44-7.76L437.4 237.4a15.5 15.5 0 1 1 26.84-15.4l22.74 39.4a15.5 15.5 0 0 1-13.4 23.24zM374.46 383.44a15.44 15.44 0 0 1-7.74-2l-39.4-22.74a15.5 15.5 0 1 1 15.5-26.84l39.4 22.74a15.5 15.5 0 0 1-7.76 28.92zM338 518.62h-45.38a15.5 15.5 0 0 1 0-31H338a15.5 15.5 0 1 1 0 31zM334.82 676.64a15.5 15.5 0 0 1-7.76-28.92l39.4-22.74a15.5 15.5 0 0 1 15.54 26.84l-39.4 22.74a15.44 15.44 0 0 1-7.78 2.08zM450.34 792.38a15.5 15.5 0 0 1-13.4-23.24l22.74-39.4a15.5 15.5 0 0 1 26.84 15.5l-22.74 39.4a15.5 15.5 0 0 1-13.44 7.74z",
    fill: "#FCC419",
    "p-id": 2325
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M382 511.44a228.34 227.82 90 1 0 455.64 0 228.34 227.82 90 1 0-455.64 0Z",
    fill: "#FCC419",
    "p-id": 2326
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M428.06 511.44a182.18 181.76 90 1 0 363.52 0 182.18 181.76 90 1 0-363.52 0Z",
    fill: "#FFD43B",
    "p-id": 2327
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M648.82 461.36a12.46 12.46 0 0 1-15.9-2.78 22.52 22.52 0 0 0-5.64-5.06 26.94 26.94 0 0 0-14.76-3.66 27.22 27.22 0 0 0-18.42 6.3 19.56 19.56 0 0 0-7.32 15.6q0 12.96 19.22 20.88l17.62 7.22q21.5 8.72 31.46 21.28a48 48 0 0 1 10 30.8q0 24.42-16.24 40.36a55.7 55.7 0 0 1-40.62 16q-23 0-38-13.64a56.14 56.14 0 0 1-14.84-23.4 13.72 13.72 0 0 1 9.84-18 13.7 13.7 0 0 1 16 9.88 26.4 26.4 0 0 0 4 8.68q8.24 11.48 24 11.46a27.84 27.84 0 0 0 20.78-8.32 29 29 0 0 0 8.24-21.22 29.86 29.86 0 0 0-1.44-9.46 24 24 0 0 0-4.46-8 35.76 35.76 0 0 0-7.84-6.76 75.46 75.46 0 0 0-11.44-6l-17.06-7.04q-36.26-15.36-36.26-44.96a42.68 42.68 0 0 1 15.22-33.36q15.2-13.52 37.86-13.54a50 50 0 0 1 38.86 17.38 12.62 12.62 0 0 1-2.86 19.36z",
    fill: "#F08C00",
    "p-id": 2328
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M609.82 635.26a14 14 0 0 1-14-14v-16a14 14 0 1 1 28 0v16a14 14 0 0 1-14 14zM609.82 442.42a14 14 0 0 1-14-14v-16a14 14 0 1 1 28 0v16a14 14 0 0 1-14 14z",
    fill: "#F08C00",
    "p-id": 2329
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M609.82 248.88a15.56 15.56 0 0 1-15.54-15.58V187.58a15.54 15.54 0 1 1 31.08 0v45.72a15.56 15.56 0 0 1-15.54 15.58zM767.78 796a15.54 15.54 0 0 1-13.48-7.8l-22.82-39.6a15.56 15.56 0 1 1 26.92-15.58l22.82 39.6a15.58 15.58 0 0 1-13.44 23.38zM883.84 679.84a15.46 15.46 0 0 1-7.76-2l-39.52-22.86a15.58 15.58 0 0 1 15.56-26.98l39.52 22.86a15.58 15.58 0 0 1-7.78 29.08zM926.46 521.06h-45.62a15.58 15.58 0 0 1 0-31.16h45.62a15.58 15.58 0 0 1 0 31.16zM844.64 385.08a15.58 15.58 0 0 1-7.8-29.08l39.52-22.86a15.58 15.58 0 0 1 15.64 26.98l-39.6 22.86a15.46 15.46 0 0 1-7.76 2.1zM745.4 285.46A15.58 15.58 0 0 1 732 262l22.82-39.6a15.56 15.56 0 1 1 26.88 15.6l-22.82 39.6a15.54 15.54 0 0 1-13.48 7.86z",
    fill: "#FCC419",
    "p-id": 2330
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M572.98 628.82c-44.7-18.68-118.76-49.62-150.16-62.64a79.54 79.54 0 0 0-30.48-6h-84.7a79.54 79.54 0 0 0-30.48 6c-31.4 13.02-105.44 44-150.16 62.64a79.5 79.5 0 0 0-46.18 52.96l-28.12 106A20.96 20.96 0 0 0 72.98 814h554a20.96 20.96 0 0 0 20.26-26.32l-28.12-106a79.5 79.5 0 0 0-46.14-52.86z",
    fill: "#495057",
    "p-id": 2331
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M261.84 552.24h185.64L360.4 874.56h-15.42l-83.14-322.32z",
    fill: "#FFFFFF",
    "p-id": 2332
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M350 681.3h11.32a2.16 2.16 0 0 0 1.78-0.94l10.8-15.84a2.14 2.14 0 0 0-0.26-2.74l-20.62-20.44a4.3 4.3 0 0 0-6 0l-20.62 20.44a2.14 2.14 0 0 0-0.26 2.74l10.8 15.86a2.16 2.16 0 0 0 1.78 0.94zM350 690.96h-8.9a4.3 4.3 0 0 0-4.28 4l-11.38 155.26a4.3 4.3 0 0 0 4.28 4.62h40.56a4.3 4.3 0 0 0 4.28-4.62l-11.38-155.26a4.3 4.3 0 0 0-4.28-4z",
    fill: "#FF6B6B",
    "p-id": 2333
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M231.38 544.16v92.4l32.24 23.64-22.58 29 87.1 153.66 11.46-7.52-65.22-304.08-43 12.9zM468.62 544.16v92.4l-32.24 23.64 22.58 29-87.1 153.66-11.46-7.52 65.22-304.08 43 12.9z",
    fill: "#868E96",
    "p-id": 2334
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M272.04 542.3h155.92L350 640.1l-77.96-97.8zM212 360.34h100v72.36h-100a36.24 36.24 0 0 1-36.26-36.24A36.2 36.2 0 0 1 212 360.34zM485.24 360.34h-100.8v72.36h100.8a36.24 36.24 0 0 0 36.26-36.24 36.2 36.2 0 0 0-36.26-36.12z",
    fill: "#F9BF87",
    "p-id": 2335
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M240.96 230.48h70.86v141.3h-101.68a26.84 26.84 0 0 1-26.84-26.84v-56.78a57.68 57.68 0 0 1 57.66-57.68zM489.6 371.78h-101.7v-141.3h70.88a57.68 57.68 0 0 1 57.6 57.68v56.76a26.84 26.84 0 0 1-26.84 26.84z",
    fill: "#495057",
    "p-id": 2336
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M228.9 302.56v-36.64a92 92 0 0 1 92-92h152a36.64 36.64 0 0 1 36.64 36.64 92 92 0 0 1-92 92h-188.64z",
    fill: "#495057",
    "p-id": 2337
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M310 292.42h80a99.72 99.72 0 0 1 99.72 99.72v40A139.76 139.76 0 0 1 350 571.84 139.76 139.76 0 0 1 210.2 432v-40a99.72 99.72 0 0 1 99.8-99.58z",
    fill: "#FFCC90",
    "p-id": 2338
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M289.82 443.86a45.42 45.42 0 1 1 45.46-45.42 45.5 45.5 0 0 1-45.46 45.42z m0-79.4a34 34 0 1 0 34 34 34 34 0 0 0-34-34.02zM410.74 443.86a45.42 45.42 0 1 1 45.46-45.42 45.5 45.5 0 0 1-45.46 45.42z m0-79.4a34 34 0 1 0 34 34 34 34 0 0 0-34-34.02z",
    fill: "#495057",
    "p-id": 2339
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M369.44 395.84c-21.78-9.78-37-0.74-37.64-0.36l-6-9.7c0.84-0.52 20.8-12.76 48.4-0.38z",
    fill: "#495057",
    "p-id": 2340
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M278.56 398.42a12.88 12.88 0 1 0 25.76 0 12.88 12.88 0 1 0-25.76 0Z",
    fill: "#495057",
    "p-id": 2341
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M393.56 398.42a12.88 12.88 0 1 0 25.76 0 12.88 12.88 0 1 0-25.76 0Z",
    fill: "#495057",
    "p-id": 2342
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M350 526a55.04 55.04 0 0 1-46.48-25.4 6 6 0 1 1 10-6.48 43.26 43.26 0 0 0 72.78 0 6 6 0 0 1 10 6.48A55.04 55.04 0 0 1 350 526z",
    fill: "#495057",
    "p-id": 2343
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient);
export default __webpack_public_path__ + "static/media/client.c473ac562738b6f7b34110c4b8cc701e.svg";
export { ForwardRef as ReactComponent };